export default [
  {
    text: 'Вакансии',
    to: { name: 'vacancies', query: { sort: 'partner' } },
    ico: 'org',
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.vacancies.js